import { Layout } from "react-grid-layout";

export default class WorkspaceLayout {
  public layout: Layout[] = [];
  public layoutInvisibleItems: Layout[] = [];
}
